export const breakpoints = {
  mobileMin: "480px",
  mobileMax: "959px",
  tabletMin: "960px",
  tabletMax: "1199px",
  desktopMin: "1200px",
};
